import AmplitudeService from "src/services/amplitude";
import {
  useEditorCodeHelpers,
  useEditorDataset,
} from "src/components/page-components/QueryPage/context";
import reservedSqlKeywords from "./reservedSqlKeywords";
import { useRouter } from "next/router";

interface Input {
  fullName: string;
}

export default function useAddTableToEditor() {
  const helpers = useEditorCodeHelpers();
  const dataset = useEditorDataset();
  const router = useRouter();
  const { category, namespace, contract, blockchains } = router.query;

  const trackEvent = (fullName: string) => {
    AmplitudeService.trackEvent("DataExplorer Insert Clicked", {
      inserted: fullName,
      category: category ?? "",
      namespace: namespace ?? "",
      contract: contract ?? "",
      blockchains: blockchains ?? "",
      table: fullName,
    });
  };

  switch (dataset?.type) {
    case "trino":
      return function addTableToEditor({ fullName }: Input) {
        trackEvent(fullName);
        // Trino is under development, and we don't know which keywords
        // to escape yet. Should escape with double quotes once ready.
        // For now, don't escape any words.
        helpers?.paste(fullName);
      };

    case "spark":
    default:
      return function addTableToEditor({ fullName }: Input) {
        trackEvent(fullName);

        if (reservedSqlKeywords.includes(fullName.toUpperCase())) {
          helpers?.paste("`" + fullName + "`");
        } else {
          helpers?.paste(fullName);
        }
      };
  }
}
